import { render, staticRenderFns } from "./RamWidget.vue?vue&type=template&id=40457c43&scoped=true&"
import script from "./RamWidget.vue?vue&type=script&lang=js&"
export * from "./RamWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40457c43",
  null
  
)

export default component.exports